import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import Layouts from "./components/Layouts";

import EmbedLayout from "./components/EmbedLayout";

import DataManagementPage from "./pages/datamanagement";
import UserPage from "./pages/User";
import Scenario from "./pages/Scenario";
import ScenarioStructure from "./pages/Scenario/Structure";
import Factor from "./pages/factor";
import Activity from "./pages/activity";
import Login from "./pages/Login";
import Emission from "./pages/emission";

function App() {
  const token = sessionStorage.getItem("token");

  return (
    <Router>
      <Switch>
        <Route path="/login" exact>
          <Login />
        </Route>
        <Route path="/embed/emissions" exact>
          <EmbedLayout>
            <Emission embed />
          </EmbedLayout>
        </Route>
        <Route path="/embed/factor" exact>
          <EmbedLayout>
            <Factor embed />
          </EmbedLayout>
        </Route>
        <Route path="/embed/activity" exact>
          <EmbedLayout>
            <Activity embed />
          </EmbedLayout>
        </Route>
        <Layouts>
          <Route path="/air-quality" exact>
            <h1 className="text-3xl text-red-500">
              ไม่มีรายละเอียดการแสดงข้อมูล
            </h1>
          </Route>
          <Route path="/emissions" exact>
            <Emission />
          </Route>
          <Route path="/emission-factor" exact>
            <Factor />
          </Route>
          <Route path="/activity" exact>
            <Activity />
          </Route>
          <Route path="/data-management" exact>
            <DataManagementPage />
          </Route>
          <Route path="/scenario" exact>
            <Scenario />
          </Route>
          <Route path="/scenario/view" exact>
            <ScenarioStructure />
          </Route>
          <Route path="/users" exact>
            <UserPage />
          </Route>
          <Redirect from="/" to={token ? "/emissions" : "/login"} />
        </Layouts>
      </Switch>
    </Router>
  );
}

export default App;
